import { useContext } from "react";
import { Routes, Route } from "react-router-dom";
import { studentRoutes } from "./AppConfig"; // adjust path as needed
import Dashboard from "./pages/dashboard/Dashboard";
import { UserContext } from "./context/UserDetails";

// Define allowed route IDs for student user_type (e.g., 2 = Student)
const routeAccessByUserType = {
  2: Array.from({ length: 65 }, (_, i) => `S${i + 1}`), // S1 to S59
};

const AppStu = () => {
  const { user } = useContext(UserContext);

  const userType = user?.user_type;
  const allowedIds = routeAccessByUserType[userType] || [];

  const filteredRoutes = studentRoutes.filter((route) =>
    allowedIds.includes(route.id)
  );
  // console.log(
  //   "Allowed Student Route Paths:",
  //   filteredRoutes.map((r) => r.path)
  // );

  return (
    <Routes>
      <Route path="/" element={<Dashboard />}>
        {filteredRoutes.map(({ id, path, element, index }) =>
          index ? (
            <Route key={id} index element={element} />
          ) : (
            <Route key={id} path={path} element={element} />
          )
        )}
      </Route>
    </Routes>
  );
};

export default AppStu;
